import React, { ChangeEvent, FC, ReactNode } from 'react'
import { SelectionStyled } from './Selection.styles'

interface SelectionProps {
  value: string
  children: ReactNode
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void
}

const Selection: FC<SelectionProps> = ({ children, ...props }) => {
  return <SelectionStyled {...props}>{children}</SelectionStyled>
}

export default Selection
